import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";
import { useTranslation } from "react-i18next";

interface DeleteConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  message?: string;
}

/**
 * Shared delete-confirmation dialog.
 * Keys resolve to localized strings where the app defines them (backoffice); the
 * German `defaultValue` is used as a fallback (reseller), preserving each app's
 * current wording without requiring shared translation files.
 */
const DeleteConfirmDialog: React.FC<DeleteConfirmDialogProps> = ({
  open,
  onClose,
  onConfirm,
  title,
  message,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>
        {title || t("Warning", { defaultValue: "Warnung" })}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {message ||
            t("DeleteDataOverviewRows", {
              defaultValue:
                "Möchten Sie die ausgewählten Einträge wirklich löschen?",
            })}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          {t("Cancel", { defaultValue: "Abbrechen" })}
        </Button>
        <Button onClick={onConfirm} color="error" variant="contained" autoFocus>
          {t("Delete", { defaultValue: "Löschen" })}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmDialog;
